// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en.json'; // English translations
// import faTranslation from './locales/fa.json'; // Persian translations

type Langs = 'fa' | 'en';
const languageFromStorage = localStorage.getItem('language') || 'en';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: languageFromStorage,
        fallbackLng: 'en', // Fallback language

        // debug: true,
        resources: {
            en: {
                translation: enTranslation,
            },
            // // fa: {
            // //     // Use 'fa' for Persian language
            // //     // translation: faTranslation,
            // // },
        },
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export const handleRTLLayout = (lng?: Langs) => {
    const lang = lng ?? languageFromStorage;
    document.documentElement.dir = ['fa'].includes(lang) ? 'rtl' : 'ltr'; // Only check 'fa' for RTL
};

i18n.on('languageChanged', (lng: Langs) => {
    handleRTLLayout(lng);
});

export const changeLanguage = (lng: Langs) => {
    localStorage.setItem('language', lng);
    i18n.changeLanguage(lng);
};

export const getCurrentLanguage = () => {
    return languageFromStorage;
};

export default i18n;
